<script>
export default {
    inject: ['$pageComponent', 'options'],

    provide() {
        return {
            $pageComponent: this.$pageComponent,
            options: this.options,
        };
    },

    data() {
        return {
            options:
                this.options !== null
                    ? this.options
                    : JSON.parse(JSON.stringify(this.$pageComponent().selection.currentSelection.canvasBlock.options)),
        };
    },

    methods: {
        save() {
            // Save by moving new options into canvas block.
            this.canvasBlock.options = this.options;
        },
    },

    computed: {
        canvasBlock() {
            return this.editorComponent.canvasBlock;
        },

        editorComponent() {
            return this.$pageComponent().selection.currentSelection;
        },

        pageComponent() {
            return this.$pageComponent();
        },

        adminUrlPrefix() {
            let htmlPrefix = $('html').data('prefix');

            return (
                '/' +
                (htmlPrefix !== undefined ? htmlPrefix : 'admin/') +
                'canvas-editor/' +
                this.pageComponent.state.canvasVersion.id +
                '/blocks/' +
                this.canvasBlock.block.replace('.', '/')
            );
        },
    },
};
</script>
